<template>
  <ul class="steps">
    <li v-for="(step, index) in stepDetails" :key="index" class="steps__section">
      <button
        class="steps__main"
        :disabled="index + 1 > activeStep"
        :aria-label="stepDetails[index].label"
        :aria-current="index + 1 === activeStep ? 'step' : undefined"
        @click="goToStep(index + 1)"
      >
        <div class="steps__main__indicator">
          <img
            v-if="isStepCompleted(index)"
            src="@/assets/images/check.svg"
            alt="Schritt abgeschlossen"
          />

          <span class="sr-only">Schritt </span>
          <span :class="{ 'sr-only': isStepCompleted(index) }">
            {{ index + 1 }}
          </span>
        </div>
        <span class="steps__main__title">{{ stepDetails[index].label }}</span>
      </button>
      <hr class="steps__line" v-if="index !== stepDetails.length - 1" />
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['activeStep', 'stepDetails']),
  },
  methods: {
    goToStep(step) {
      // cancel appointment if going back from overview page
      if (this.activeStep === 5) this.$store.dispatch('deleteLockedAppointment')

      this.$store.commit('setActiveStep', step)
    },
    isStepCompleted(index) {
      return this.stepDetails[index].isComplete && index + 1 !== this.activeStep
    },
  },
}
</script>

<style lang="scss">
.steps {
  display: flex;
  margin: 0 0 48px 0;

  @media (max-width: 650px) {
    margin: 0 8px 60px 8px;
  }

  @media (max-width: $breakpoint-max-mobile) {
    margin: 16px 8px 60px 8px;
  }

  &__section {
    margin: 0;
    padding: 0;
    list-style: none;
    &:not(:last-of-type) {
      display: flex;
      width: 100%;
    }
  }

  &__main {
    @include flex-center-align;
    font-size: 12px;
    font-weight: $font-weight-medium;
    position: relative;
    cursor: pointer;

    > .steps__main__indicator {
      background-color: $color-info-primary;
      border-color: transparent;
    }

    &__indicator {
      @include flex-center;
      border-radius: 50%;
      line-height: 21px;
      margin-right: 8px;
      height: 20px;
      width: 20px;

      @media (max-width: 650px) {
        margin-right: 0;
      }
    }

    &__title {
      @media (max-width: 650px) {
        position: absolute;
        top: 24px;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    &:disabled {
      cursor: default;
      pointer-events: none;

      > .steps__main__indicator {
        border: 1px solid $color-text-secondary;
        color: $color-text-secondary;
        background-color: transparent;
      }
      > .steps__main__title {
        color: $color-text-secondary;
      }
    }

    &[aria-current] {
      > .steps__main__indicator {
        color: white;
      }
    }
  }

  &__line {
    margin: 10px 16px 0 16px;
    height: fit-content;
    width: 100%;

    @media (max-width: 650px) {
      margin: 10px 8px 0 8px;
    }
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
</style>
